module.exports = __webpack_public_path__ + "img/west-sussex-wellbeing.bd89d8f7.png";